import { CourseMaterial } from "./coursesLoader.ts";
import { FormattedMessage } from "react-intl";
import DotLoader from "../../../../common/core-ui/DotLoader.tsx";
import useMaterialOptInOutStatus from "./useMaterialOptInOutStatus.tsx";
import styles from "./MaterialOptInOutStatus.module.scss";
import { useEffect, useRef } from "react";
import { deferFn } from "../../../../common/utils/function.ts";

export default function MaterialOptInOutStatus({
  material,
}: {
  material: CourseMaterial;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { optingInOutMessage, isOptInOutProcessing } =
    useMaterialOptInOutStatus(material);

  useEffect(() => {
    // deferred focus because closing dialog might try and set focus
    deferFn(() => {
      if (isOptInOutProcessing && containerRef.current) {
        containerRef.current.focus();
      }
    });
  }, [isOptInOutProcessing]);

  if (!isOptInOutProcessing) {
    return null;
  }

  return (
    <div ref={containerRef} className={styles.container} tabIndex={-1}>
      <div role="status" aria-live="polite" aria-atomic="false">
        <FormattedMessage defaultMessage={"Please wait"} />
        <DotLoader dotCount={3} size={"small"} />
      </div>
      <div>{optingInOutMessage}</div>
    </div>
  );
}
